module.exports = __webpack_public_path__ + "static/img/Header_1920x380_reproductive-health-nipt.b898caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-test/Header_1920x380_reproductive-health-nipt.jpg
// module id = aYfa
// module chunks = 0